import { render, staticRenderFns } from "./addNewInvestmentPopup.vue?vue&type=template&id=379b9942&scoped=true"
import script from "./addNewInvestmentPopup.vue?vue&type=script&lang=js"
export * from "./addNewInvestmentPopup.vue?vue&type=script&lang=js"
import style0 from "./addNewInvestmentPopup.vue?vue&type=style&index=0&id=379b9942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b9942",
  null
  
)

export default component.exports